import { RouterModule, Routes } from '@angular/router';
import { Page404Component } from './resources/extrapages/page404/page404.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/main/layout.component';
import { AuthComponent } from './layouts/auth/auth.component';
import { extraPagesComponent } from './layouts/extra-pages/extra-pages.component';

export const routes: Routes = [
    {
        path: "auth",
        component: AuthComponent,
        loadChildren: () =>
            import("./resources/account/account.module").then((m) => m.AccountModule),
    },
    {
        path: "",
        component: LayoutComponent,
        loadChildren: () =>
            import("./resources/pages/pages.module").then((m) => m.PagesModule),
        canActivate: [AuthGuard],
    },
    {
        path: "pages",
        loadChildren: () =>
            import("./resources/extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
        canActivate: [AuthGuard],
    },
    {   
        path: "**", 
        component: extraPagesComponent, 
        loadChildren: () =>
            import("./resources/extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
    },
];
